import React from "react"
import PropTypes from "prop-types"
import Icon from '../app_components/Icon'
import { semantic } from '@lexody/design-tokens'


class SettingMenuItem extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div
        className="sideNav-settings__item"
        onClick={() => this.props.onClick()}>
        <h4>{this.props.title}</h4>
        <Icon
          name="arrow-right"
          size={16}
          color={semantic.primary.surface.default}
          style={{ marginRight: 10 }}
        />
      </div>
    )
  }

}

export default SettingMenuItem;
